import { SxProps, Theme } from '@mui/material'

export const cardSx: SxProps<Theme> = {
  borderRadius: 3,
  borderColor: '#e0d7e4',
}

export const sectionTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  color: '#2c063f',
}

export const subtleLabelSx: SxProps<Theme> = {
  color: '#a08fa8',
}

export const primaryButtonSx: SxProps<Theme> = {
  backgroundColor: '#fa624b',
  color: '#2c063f',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 2,
  px: 2.5,
  py: 0.75,
  boxShadow: 'none',
  '&:hover': { backgroundColor: '#e5432e', boxShadow: 'none' },
  '&.Mui-disabled': {
    backgroundColor: '#e0d7e4',
    color: '#a08fa8',
  },
}

export const outlinedButtonSx: SxProps<Theme> = {
  color: '#2c063f',
  borderColor: '#cac0cf',
  '&:hover': { borderColor: '#2c063f', backgroundColor: '#f5f2f7' },
}

export const checkboxSx: SxProps<Theme> = {
  color: '#cac0cf',
  '&.Mui-checked': { color: '#fa624b' },
}

export const switchSx: SxProps<Theme> = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: '#fa624b' },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#fa624b' },
}

// Spread onto a form's outer container to shrink every nested TextField uniformly —
// MUI's "small" size alone still renders fairly tall, generously-padded inputs.
export const compactFormSx: SxProps<Theme> = {
  '& .MuiInputBase-input': { fontSize: 13.5, paddingTop: '7px', paddingBottom: '7px' },
  '& .MuiInputLabel-root': { fontSize: 13.5 },
  '& .MuiFormHelperText-root': { fontSize: 11, marginTop: 2, marginLeft: 0 },
}

export const tableHeadCellSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: 12,
  backgroundColor: '#f5f2f7',
  color: '#2c063f',
  borderBottom: '1px solid #e0d7e4',
}
